// src/api/services/applicationDocumentService.ts
import api from "../axios";

export interface ApplicationDocumentDto {
  id: number;
  createdAt: string;
  type: string;
  file: {
    uuid: string;
    fileName: string;
    url: string;
  };
}

export interface CreateDocumentPayload {
  type: string;
  uploadUuid: string;
}

export function getDocumentsByType(applicationUuid: string, type: string) {
  return api.get<ApplicationDocumentDto[]>(`/applications/${applicationUuid}/documents`, {
    params: { type },
  });
}

export function deleteDocument(applicationUuid: string, documentId: number) {
  return api.delete(`/applications/${applicationUuid}/documents/${documentId}`);
}

export function createDocument(
  applicationUuid: string,
  payload: CreateDocumentPayload
) {
  return api.post(`/applications/${applicationUuid}/documents`, payload);
}